import axios from 'axios';

// get data from app
const state = {
  status: '',
  token: '',
  user: {},
};

// show data in app component
const getters = {
  authStatus: state => state.status,
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, token, user) {
    state.status = 'success';
    state.token = token;
    state.user = user;
  },
  auth_error(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
  },
};

const actions = {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios({ url: 'http://localhost:3000/api/users/login', data: user, method: 'POST' })
        .then((res) => {
          const { token } = res.data;
          const { user } = res.data;
          commit('auth_success', token, user);
          resolve(res);
        })
        .catch((err) => {
          commit('auth_error');
          reject(err);
        });
    });
  },
  register({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios({ url: 'http://localhost:3000/api/register', data: user, method: 'POST' })
        .then((res) => {
          const { token } = res.data;
          const { user } = res.data;
          commit('auth_success', token, user);
          resolve(res);
        })
        .catch((err) => {
          commit('auth_error', err);
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('logout');
      resolve();
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
